export default __webpack_public_path__ + "static/media/terms.d57adbe2.svg";